"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../core");
var i_st_1 = require("../../core/st/interface/i$st");
var iattributes_1 = require("./interface/iattributes");
var type_function_1 = require("../../core/lang/type-function");
var type_object_1 = require("../../core/lang/type-object");
var type_undefined_1 = require("../../core/lang/type-undefined");
var dom_1 = require("./dom");
exports.tsxToStandardAttributeName = function (tsxAttributeName) {
    // support for SVG xlink:*
    if (tsxAttributeName.startsWith(dom_1.XLINK_ATTRIBUTE_NAME)) {
        return (dom_1.XLINK_ATTRIBUTE_NAME + ":" + tsxAttributeName.replace(dom_1.XLINK_ATTRIBUTE_NAME, "")).toLowerCase();
    }
    switch (tsxAttributeName) {
        // support for React className -> class
        case dom_1.CLASS_NAME_ATTRIBUTE_NAME:
            return dom_1.CLASS_ATTRIBUTE_NAME;
    }
    return tsxAttributeName;
};
// If a JSX comment is written, it looks like: { /* this */ }
// Therefore, it turns into: {}, which is detected here
exports.isJSXComment = function (node) {
    return node && typeof node === type_object_1.TYPE_OBJECT && (!node.attributes && !node.type && !node.children);
};
// Implementation to flatten virtual node children structures like:
// [<p>1</p>, [<p>2</p>,<p>3</p>]] to: [<p>1</p>,<p>2</p>,<p>3</p>]
exports.toFlatNodeList = function (children) {
    return [].concat.apply([], children);
};
// Filters comments and undefines like: [undefined, 'a', 'b', false, {}] to: ['a', 'b', false]
exports.filterCommentsAndUndefines = function (children) {
    return children.filter(function (child) { return typeof child !== type_undefined_1.TYPE_UNDEFINED && !exports.isJSXComment(child); });
};
exports.cmpSequence = 0;
exports.newUniqueComponentName = function () { return "fnc-" + ++exports.cmpSequence; };
exports.tsx = (core_1.st.tsx = function (
// if it is a function, it is a component
type, attributes) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    children = exports.filterCommentsAndUndefines(exports.toFlatNodeList(children));
    // clone attributes as well
    attributes = __assign({}, attributes);
    // effectively unwrap by directly returning the children
    if (type === dom_1.FRAGMENT_ELEMENT_NAME || attributes[iattributes_1.UNWRAP_ATTRIBUTE_NAME]) {
        return exports.filterCommentsAndUndefines(children);
    }
    var slotChildren = {};
    // it's a component, divide and conquer children
    if (typeof type === type_function_1.TYPE_FUNCTION) {
        // try to infer type via function name
        type = core_1.st[i_st_1.GlobalCache.COMPONENT_WEAKMAP].get(type);
        if (process.env.NODE_ENV === "development") {
            // assign debug className flag
            attributes.__className = type;
        }
        // <template> elements are to be moved inside slotChildren
        for (var i = 0; i < children.length; i++) {
            // --- <template> discovery and divide & conquer algorithm to find named and default children
            if (children[i] && children[i].type === dom_1.TEMPLATE_ELEMENT_NAME) {
                //templateTagFound = true;
                // last one wins if the same name occurs more than once
                slotChildren[children[i].attributes[iattributes_1.SLOT_ATTRIBUTE_NAME]] = children[i];
            }
            else {
                // stack
                if (!slotChildren[dom_1.DEFAULT_SLOT_NAME]) {
                    slotChildren[dom_1.DEFAULT_SLOT_NAME] = [];
                }
                slotChildren[dom_1.DEFAULT_SLOT_NAME].push(children[i]);
            }
        }
        // <template> behaviour: disable direct 1:1 inject; children stored in slotChildren are rendered
        // via this.renderChildren() and this.renderSlot(...) respectively in components
        children = [];
    }
    // @ts-ignore as type allows for Function here, but internally we wouldn't
    // want to deal with Function, only "string". However, in this method it is indeed possible
    return {
        type: type,
        attributes: attributes,
        children: children,
        slotChildren: slotChildren,
    };
});
//# sourceMappingURL=tsx.js.map